//  Formats a Date object into a string in the format YYYY-MM-DD.

export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const formatTime = (timestamp: string): string => {
  const date = new Date(timestamp); // Date object automatically converts UTC to local time
  let hours = date.getHours();
  // Pad minutes correctly as a string using padStart
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = hours >= 12 ? 'PM' : 'AM';
  // Convert hours to 12-hour format:
  hours = hours % 12;
  // The hour '0' should be '12'
  hours = hours ? hours : 12;

  // The minutes variable is already correctly formatted as a padded string
  return `${hours}:${minutes} ${amOrPm}`;
};
